// src/context/DataContext.js
import React, { createContext, useContext, useState } from "react";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const getInitialGlobalData = () => {
    const storedDetails = localStorage.getItem("details");
    if (!storedDetails) return null;

    try {
      return JSON.parse(storedDetails)?.detail || null;
    } catch (_) {
      return null;
    }
  };

  // Generic states
  const [loader, setLoader] = useState(false);  
  const [invoices, setInvoices] = useState([]);

  const [globalData,setGlobalData]=useState(getInitialGlobalData)
  const [user, setUser] = useState(null);             // User info
  const [alert, setAlert] = useState({                // Global alert
    open: false,
    message: "",
    type: "info",
  });
  const [dialog, setDialog] = useState({              // Global dialog
    open: false,
    title: "",
    content: "",
  });

  // Example utility functions
  const openAlert = (message, type = "info") => setAlert({ open: true, message, type });
  const closeAlert = () => setAlert((prev) => ({ ...prev, open: false }));

  const openDialog = (title, content) => setDialog({ open: true, title, content });
  const closeDialog = () => setDialog((prev) => ({ ...prev, open: false }));

  return (
    <DataContext.Provider
      value={{
        loader,
        setLoader,
        user,
        setUser,
        alert,
        openAlert,
        closeAlert,
        dialog,
        openDialog,
        closeDialog,
        globalData,setGlobalData,invoices, setInvoices
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
